interface ConfirmDialogProps {
  bits: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({ bits, onConfirm, onCancel }: ConfirmDialogProps) {
  return (
    <div className="confirm-dialog">
      <h3>Confirmar Desenho</h3>
      <div className="cost">{bits} Bits</div>
      <p style={{ marginBottom: '16px', opacity: 0.8, fontSize: '14px' }}>
        Seu desenho vai aparecer para todos na stream!
      </p>
      <div className="buttons">
        <button className="cancel-btn" onClick={onCancel}>
          Cancelar
        </button>
        <button className="confirm-btn" onClick={onConfirm}>
          Pagar com Bits
        </button>
      </div>
    </div>
  );
}
